import de from './de';
import es from './es';
import fr from './fr';
import gb from './gb';
import it from './it';

export default {
    de,
    es,
    fr,
    gb,
    it,
};
